import type { LucideIcon } from "lucide-react";
import {
  Facebook,
  Twitter,
  Instagram,
  Linkedin,
  Youtube,
  Github,
  Globe,
  MapPin,
  Music2,
} from "lucide-react";
import { detectFooterSocial, type FooterSocialKey } from "@shared/footerModel";

// Social-link detection lives in @shared/footerModel so the website footer
// (Contact.tsx) and the server-rendered legal-page footer (server/routes.ts)
// agree on which platform a URL maps to. Here we only attach the lucide icon
// component for that platform; ContactCard + the React footer keep consuming the
// SocialMeta shape below unchanged.
export const SOCIAL_ICONS: Record<FooterSocialKey, LucideIcon> = {
  facebook: Facebook,
  twitter: Twitter,
  instagram: Instagram,
  linkedin: Linkedin,
  youtube: Youtube,
  tiktok: Music2,
  github: Github,
  googleBusiness: MapPin,
  globe: Globe,
};

export type SocialMeta = {
  icon: LucideIcon;
  label: string;
  href: string;
  isWebsite: boolean;
};

export function detectSocial(rawUrl: string): SocialMeta | null {
  const s = detectFooterSocial(rawUrl);
  if (!s) return null;
  return {
    icon: SOCIAL_ICONS[s.key],
    label: s.label,
    href: s.href,
    isWebsite: s.key === "globe",
  };
}
